<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
    var resultData = [{
        name:'设备1',
        maxHP:50,
        },{
        name:'设备2',
        maxHP:80,
        },{
        name:'设备3',
        maxHP:50,
    },{
        name:'设备4',
        maxHP:60,
        },{
        name:'设备5',
        maxHP:80,
        },{
        name:'设备6',
        maxHP:20,
    },{
        name:'设备7',
        maxHP:60,
        },{
        name:'设备8',
        maxHP:80,
        },{
        name:'设备9',
        maxHP:20,
    }]

    this.state.chart.setOption({
        tooltip:{
            trigger:'axis',
            axisPointer:'shadow',
            formatter(param){
                let html = '';
                if(param.length>0){
                    const {value,marker} = param[0];
                    html += `${marker}${value.name}:${value,maxHP}个`
                }
                return html;
            }
        },
        grid: {
            left: '25px',
            right: '25px',
            bottom: '20px',
            top:'70px',
            containLabel: true
        },
        dataset:[
            {
                source:resultData,
                dimensions:['name','maxHP']
            }
        ],
        xAxis:[
            {
                type:'category',
                axisLabel:{
                    interval:0,
                    color:'rgba(255,255,255,.8)',
                    fontSize:13,
                },
                axisLine:{
                    show:true,
                    lineStyle:{
                    color:'#102825',
                    },
                },
                axisTick:{
                    show:false,
                },
                axisPointer:{
                    type:'shadow',
                }
            }
        ],
        yAxis:[
            {
            type:'value',
            name:'分钟',
            nameTextStyle:{
                color:'rgba(255,255,255,.8)',
                padding:[0,0,0,-30],
            },
            axisTick:{
                show:false,
            },
            axisLine:{
                show:true,
                lineStyle:{
                color:'#102825'
                },
            },
            axisLabel:{
                interval:0,
                color:'rgba(255,255,255,.8)',
            },
            splitLine:{
                show:false,
                lineStyle:{
                type:'dashed',
                color:'#004B97'
                }
            }
        }
        ],
        series:[
            {  
                //柱子底部
                name:'',
                type:'pictorialBar',
                symbolSize:[20,8],
                symbolOffset:[0,3],
                z:12,
                itemStyle:{
                    normal:{
                    color:'#006d54',
                    },
                },
                encode:{
                    x:'name',
                    y:'maxHP'
                }
            },
            {  
                //柱体
                name:'',
                type:'bar',
                barWidth:20,
                barGap:'0%',
                itemStyle:{
                    normal:{
                    color:{x:0,y:0,x2:0,y2:1,type:'linear',global:false,colorStops:[
                        {offset:0,color:'rgba(73,246,210,.6)'},
                        {offset:1,color:'rgba(1,151,117,.8)'}
                    ]},
                    },
                },
                encode:{
                    x:'name',
                    y:'maxHP'
                }
            },
            {  
                //柱子顶部
                name:'',
                type:'pictorialBar',
                symbolSize:[20,8],
                symbolOffset:[0,-3],
                z:12,
                symbolPosition:'end',
                label:{
                    show:true,
                    position:'top',
                    textStyle:{
                    fontSize:10,
                    color:'#fff'
                    }
                },
                itemStyle:{
                    normal:{
                    color:'#00c195',
                    },
                },
                encode:{
                    x:'name',
                    y:'maxHP'
                }
            }
        ]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
